import { network } from 'services/network';

export const exportProjectDataAsFile = (params) => {
    const fileName = params.exportType === 'XER' ? `${params.fileName}.xer` : `${params.fileName}.mpp.xml`;
    delete params.fileName;

    return network.post('api/bo/exportProjectDataAsFile', params).then((response) => {
        const blob = new Blob([response.data], {
            type: 'text/plain',
        });
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        a.click();

        return true;
    });
};
